import React from 'react';
import { Navigate } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-dark-bg">
        <div className="text-center">
          {/* Branded loader */}
          <div className="relative mb-6">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-400/20 to-teal-500/20 border border-accent-green/20 flex items-center justify-center mx-auto animate-pulse-soft">
              <BarChart3 size={28} className="text-accent-green" />
            </div>
            <div className="absolute inset-0 w-16 h-16 rounded-2xl mx-auto border-2 border-accent-green/30 border-t-accent-green animate-spin" style={{ animationDuration: '1.5s' }} />
          </div>
          <p className="text-gray-400 text-sm font-medium">Loading your dashboard...</p>
          <p className="text-gray-600 text-xs mt-1">Connecting to TrackMyFxEA</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
